import React from 'react'
import PropTypes from 'prop-types'
import { Form, Row, Col, Label } from 'reactstrap'
import { Select } from 'components/select'
import Button from 'components/buttons/button'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import { localized } from 'decorators'
import { iconsCreator } from 'utils/iconsCreator'
import { themes, loadTheme } from 'themes'

export class ChangeThemeDialog extends DialogBase {
  static propTypes = {
    context: PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string,
      onClose: PropTypes.func.isRequired,
      initialState: PropTypes.shape({
        text: PropTypes.string,
        number: PropTypes.string
      }).isRequired
    }).isRequired
  }
  constructor (props, context) {
    super(props, context)

    this.state = {
      selectedTheme: loadTheme().id
    }
  }
  modalButtons () { return <Button width={200} icon={iconsCreator('PaletteIcon')} onClick={() => this.close()}>{this.props.localize('common.changeTheme')}</Button> }
  modalSize () { return dialogSizes.MD }
  modalBody () {
    const { localize } = this.props
    return (
      <Form>
        <Row>
          <Col sm='12'>
            <Label>{localize('common.selectTheme')}</Label>
            <Select
              data={themes}
              value={this.state.selectedTheme}
              isSearchable={false}
              onChange={(selectedTheme) => this.setState({ selectedTheme })} />
          </Col>
        </Row>
      </Form>
    )
  }
}

export default localized(ChangeThemeDialog)
